// =========================================================================
// SHARED I18N / ROUTING TYPES
// =========================================================================

/** Supported site languages. English is the default and the x-default target. */
export type Lang = "en" | "es";

export const LANGS: Lang[] = ["en", "es"];

/** Every public marketing page. One key => one URL per language. */
export type PageKey =
  | "home"
  | "services"
  | "hosting"
  | "solutions"
  | "areas"
  | "about"
  | "contact"
  | "managed-it"
  // Dedicated, conversion-focused Google Ads landing page — distinct from the
  // informational "managed-it" service page above. Message-matches ad copy
  // for "managed IT services" / "IT support Tampa" style searches.
  | "managed-it-services"
  | "network-installation"
  | "security-cameras"
  | "server-cloud"
  | "website-development"
  | "it-consulting"
  | "privacy";

export type SeoConfig = {
  title: string;
  description: string;
  ogTitle: string;
  ogDescription: string;
  keywords?: string;
};
